// extracted by mini-css-extract-plugin
export default {"wrapper":"upload-modal_wrapper__JZwtV"};